module.exports = __webpack_public_path__ + "media/images/remember-logo-5d6fb57b6e9dbcf460ec424e43049a09.svg";